import React from 'react';

var sources = require('../../config.json');

const CategorySelectButtons = (props) => {
	return (
		<div className="category-switcher-btn-row">
			<button onClick={categorySwitcher.bind(this, 0, props.onCategoryReset)} className="category-switcher-btn reset-switcher-btn">{sources.locationname}</button>
			{props.markerGroups.map((markerGroup) => <button key={markerGroup.id} onClick={categorySwitcher.bind(this, markerGroup.id, props.onCategoryChange)} className={"category-switcher-btn " + markerGroup.colorClass}><img src={markerGroup.icon} alt="filter selector" /> <span>{markerGroup.groupName}</span></button>)}
		</div>
	);
};

function categorySwitcher(id, categoryChangeFunc) {
	categoryChangeFunc(id);
}


export default CategorySelectButtons;


/** WEBPACK FOOTER **
 ** ./src/modules/location/elements/CategorySelectButtons.js
 **/